<div class="m-0.5">

  <section id="weather" class="grid grid-cols-2 divide-x-1 divide-gray-200 md:max-w-lg
  md:h-fit md:border md:rounded-lg md:border-gray-200 md:mb-2.5">
    <app-weather-today></app-weather-today>
    <app-weather-tomorrow></app-weather-tomorrow>
  </section>

  <section id="energy-price" class="grid grid-cols-1 md:grid-cols-2 md:max-w-lg
  md:h-fit md:border md:rounded-lg md:border-gray-200 md:mb-2.5">
    <a routerLink="/price-chart" class="block md:border-r border-gray-200">
      <app-energy-price-current type="consumption"></app-energy-price-current>
    </a>
    <a routerLink="/price-chart" class="block">
      <app-energy-price-current type="feed-in"></app-energy-price-current>
    </a>
    <app-energy-price-market class="md:col-span-2 border-t border-gray-200"></app-energy-price-market>
  </section>


  <div id="performance" class="md:border md:rounded-lg md:border-gray-200 ">

    <div class="px-4 pl-3 py-4 mb-2 md:grid md:grid-cols-2 md:grid-cols-[20%_80%]
      gap-1">

      <h1 class="md:text-xl pt-1.5 hidden md:grid">Meine Anlage</h1>
<div class="grid grid-cols-2 grid-cols-[95%_5%] md:grid-cols-[97%_3%]">
    <mat-button-toggle-group [value]="selectedStartpageoption()"
                             (change)="onSwitchToggle($event)"
                             class="custom-switch flex border-gray-200 mr-2
                             md:mr-40 mb-3.5 rounded-lg break-words">
      <mat-button-toggle value="Status"
                         class="flex-1 border-gray-200 bg-production-yellow break-words w-full overflow-hidden">
        Aktueller Status
      </mat-button-toggle>
      <mat-button-toggle value="Balance"
                         class="flex-1 border-gray-200 bg-consumption-blue break-words w-full overflow-hidden">
        Energie-Bilanz
      </mat-button-toggle>
    </mat-button-toggle-group>


    <a [routerLink]="chartLinkText" class="mt-1">
        <img src="/../assets/chevron-right.svg" class="h-8 w-8" alt="Chevron-right menu link">
      </a>

</div>
    </div>


    @if (this.selectedStartpageoption() === 'Status')  {

      <section id="status">

        <div class="status-inner-wrapper md:grid md:grid-cols-2 md:grid-cols-[75%_25%]">
          <section class="px-4 py-2 live-chart-wrapper md:grid">

            <!-- SVG Live Chart-->
            <app-live-chart></app-live-chart>

          </section>

          <section id="Details" cdkAccordion class="md:max-w-lg md:items-start">

            <button
              class="example-accordion-item-header flex items-center md:items-start w-full px-4 py-2 font-bold"
              (click)="accordionItem.toggle()"
              tabindex="0"
              [attr.id]="'cdkAccordionItem'"
              [attr.aria-expanded]="accordionItem.expanded"
              [attr.aria-controls]="'accordion-body'">
              Details
              <div class="example-accordion-item-description ml-auto">
           <mat-icon
             class="transition-transform duration-300"
             [class.rotate-180]="accordionItem.expanded">
  {{ accordionItem.expanded ? 'remove' : 'add' }}
</mat-icon>
          </div>
            </button>

            <cdk-accordion-item #accordionItem="cdkAccordionItem" class="example-accordion-item">
              <div #body
                   class="accordion-body"
                   [style.maxHeight.px]="accordionItem.expanded ? body.scrollHeight : 0"
                   [class.expanded]="accordionItem.expanded">
                <app-energy-status></app-energy-status>
              </div>
            </cdk-accordion-item>
          </section>
        </div>
      </section>

    }

    @if (this.selectedStartpageoption() === 'Balance') {

      <div class="infotext pt-0 pb-0 p-8">Dieses Diagramm veranschaulicht, wohin die erzeugte Energie geflossen ist und aus
        welchen Quellen sie stammt. Die durch die Produktion generierte Energiemenge ist in beiden Balken identisch.
        <!-- <a href="#" class="underline">Mehr erfahren.</a>-->
      </div>


      <div class="p-4">
        <app-daily-energy-balance></app-daily-energy-balance>
      </div>
    }

  </div>

  <section id="schedule" class="md:max-w-lg">
    <!--<h2>Energy+ Fahrplan</h2><br>
    coming soon...-->
  </section>

  <div id="news" class="md:border md:rounded-lg md:border-gray-200 md:mt-2.5 border-t-1 border-gray-200">
    <div class="px-4 pl-3 py-4 mb-2 grid grid-cols-2 grid-cols-[95%_5%] md:grid-cols-[97%_3%]
      gap-1">

        <h2 class="md:text-xl pt-1.5 md:grid">News</h2>

        <a href="https://energyplus.at/privatkunden-blog/" target="_blank" class="mt-1">
          <img src="/../assets/chevron-right.svg" class="h-8 w-8" alt="Chevron-right menu link">
        </a>

    </div>

    <div class="md:px-4 pl-3 py-4 md:mb-2 md:grid md:grid-cols-3 md:grid-cols-[33%_33%_33%]
      gap-1">
      <div class="news-item-container">
          <div class="news-image pb-2 pr-4">
            <img src="/../images/PV-im-Sommer_web.png" alt="">
          </div>
          <h4 class="pb-2 pt-2 news-headline">PV-Strom optimal nutzen</h4>
          <p class="news-text pr-8 mb-4">Volle Sonne, volle Leistung – doch wohin mit dem erzeugten PV-Strom? Mit der richtigen Strategie nutzen Sie Ihre Sonnenenergie im Sommer noch besser.</p>
          <a href="https://energyplus.at/pv-strom-im-sommer-optimal-nutzen/" target="_blank" class="cursor-pointer"><button class="news-button cursor-pointer pb-2 pt-2 pr-6 pl-6 mb-8">Mehr erfahren</button></a>
      </div>

    <div class="news-item-container">
      <div class="news-image pb-2 pr-4">
        <img src="/../images/Stromspeicher_Optimieren.png" alt="">
      </div>
      <h4 class="pb-2 pt-2 news-headline">Stromspeicher optimieren</h4>
      <p class="news-text pr-8 mb-4">Ihr Stromspeicher kann mehr als nur PV-Strom zwischenspeichern. Mit der richtigen Strategie nutzen Sie seine Möglichkeiten deutlich effizienter.</p>
      <a href="https://energyplus.at/stromspeicher-optimieren/" target="_blank" class="cursor-pointer"><button class="news-button cursor-pointer pb-2 pt-2 pr-6 pl-6  mb-8">Mehr erfahren</button></a>
    </div>

  <div class="news-item-container">
    <div class="news-image pb-2 pr-4">
      <img src="/../images/Gewerbespeicher.png" alt="">
    </div>
    <h4 class="pb-2 pt-2 news-headline">Gewerbespeicher wirtschaftlich nutzen</h4>
    <p class="news-text pr-8 mb-4">Ein Gewerbespeicher bietet mehr als zusätzliche Kapazität. Richtig eingesetzt, reduziert er Lastspitzen und verbessert die Wirtschaftlichkeit.</p>
    <a href="https://energyplus.at/gewerbespeicher-wirtschaftlich-betreiben/" target="_blank" class="cursor-pointer"><button class="news-button cursor-pointer pb-2 pt-2 pr-6 pl-6 mb-8">Mehr erfahren</button></a>
  </div>

  </div>

 </div>
</div>
